// ── PID: 시스템 ───────────────────────────────────────────
export const PID_SYSTEM = '00001'

// ── PID: 사용자 (10xxx) ──────────────────────────────────
export const PID_USER_REGISTER  = '10001'
export const PID_USER_LOGIN     = '10002'
export const PID_USER_LOGOUT    = '10003'
export const PID_USER_DUP_CHECK = '10004'

// ── PID: 구단 (11xxx) ────────────────────────────────────
export const PID_CLUB_CREATE = '11001'
export const PID_CLUB_LOAD   = '11002'

// ── PID: 선수 (12xxx) ────────────────────────────────────
export const PID_PLAYER_LIST          = '12001'
export const PID_PLAYER_DETAIL        = '12002'
export const PID_PLAYER_STATUS_LIST   = '12003'
export const PID_PLAYER_STATUS_UPSERT = '12004'
export const PID_PLAYER_STATUS_CLEAR  = '12005'

// ── PID: 전술 (13xxx) ───────────────────────────────────
export const PID_TACTICS_LOAD     = '13001'
export const PID_TACTICS_SAVE     = '13002'
export const PID_TACTICS_ACTIVATE = '13003'

// ── PID: 일정/순위/매치 (14xxx) ─────────────────────────
export const PID_FIXTURE_LIST     = '14001'
export const PID_LEAGUE_TABLE     = '14002'
export const PID_MATCH_START_LIVE = '14101'
export const PID_MATCH_LOG_LIST   = '14102'
export const PID_MATCH_STATS      = '14103'
export const PID_MATCH_LIVE_SUB     = '14104'
export const PID_MATCH_LIVE_FORM    = '14105'
export const PID_MATCH_LIVE_CONSOLE = '14106'
export const PID_MATCH_MOM_LIST   = '14107'  // 경기 MoM·선수 평점 (Phase 8-C-5)
export const PID_SETPIECE_STATS   = '14108'  // 세트피스 리그·시즌 통계
export const PID_ROUND_ADVANCE    = '14201'

// ── PID: 이적시장 (15xxx) ───────────────────────────────
export const PID_TRANSFER_LIST       = '15001'
export const PID_TRANSFER_BUY        = '15002'
export const PID_TRANSFER_LIST_USER  = '15003'
export const PID_TRANSFER_CANCEL     = '15004'
export const PID_TRANSFER_BID        = '15005'
export const PID_TRANSFER_BID_LIST   = '15006'

// ── PID: 재계약 (12xxx) ─────────────────────────────────
export const PID_RENEW_LIST = '12010'
export const PID_RENEW_SIGN = '12011'

// ── PID: 주식 (17xxx) ───────────────────────────────────
export const PID_STOCK_LIST    = '17001'
export const PID_STOCK_HISTORY = '17002'
export const PID_STOCK_BUY     = '17003'
export const PID_STOCK_SELL    = '17004'

// ── PID: 은행 (18xxx) ───────────────────────────────────
export const PID_LOAN_LIST     = '18001'
export const PID_LOAN_APPLY    = '18002'
export const PID_LOAN_REPAY    = '18003'
export const PID_DEPOSIT_LIST  = '18004'
export const PID_DEPOSIT_OPEN  = '18005'
export const PID_DEPOSIT_CLOSE = '18006'

// ── PID: 컵대회 (Phase 6.3) ──────────────────────────────
export const PID_CUP_APPLY   = '18101'
export const PID_CUP_CANCEL  = '18102'
export const PID_CUP_LIST_MY = '18103'

// ── PID: 챔피언스리그 (Phase 6.4) ────────────────────────
export const PID_CHAMPIONS_APPLY = '18201'

// ── PID: 뉴스 (발전 D, 18301~) ──────────────────────────
export const PID_NEWS_LIST = '18301'

// ── PID: 재정 (16xxx) ───────────────────────────────────
export const PID_FINANCE_LEDGER  = '16001'
export const PID_FINANCE_SUMMARY = '16002'

// ── PID: 시즌 (19xxx) ───────────────────────────────────
export const PID_SEASON_END = '19001'

// ── PID: 관리자 (99xxx) ─────────────────────────────────
export const PID_ADMIN_SEED_LEAGUE = '99001'

// ── PID 카테고리 (할당 예정) ────────────────────────────
// 15xxx TRANSFER, 16xxx FINANCE, 17xxx STOCK, 18xxx NEWS
